import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import DynamicForm from "./Form";
import ApiService from "../helpers/Services";
import { PropagateLoader } from "react-spinners";
import swal from "sweetalert";
import "./layout.css"; // Import a CSS file for custom styling
import SplitPane from "react-split-pane";
import Config from "../Config";

const Layout = ({ token }) => {
  const [loading, setLoading] = useState(false);
  const [doc, setDoc] = useState(null);
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [textBoxValue, setTextBoxValue] = useState("");
  const [zoomLevel, setZoomLevel] = useState(1.0);
  const isPdf = (fileName) => {
    return fileName && fileName.toLowerCase().includes('.pdf');
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleLogout = () => {
    const cognitoDomain = "your-cognito-domain";
    const clientId = "your-client-id";
    const region = "your-region"; // e.g., 'us-east-1'
    const logoutUri = encodeURIComponent("http://localhost:3000/"); // replace with your redirect URI

    const logoutUrl = Config.LogoutUrl;
    window.location.href = logoutUrl;
  };

  const getTask = async (textValue) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const data = await ApiService.post("assign-task", { "clientItemId": textValue.trim() }, headers);
      setLoading(false);
      setDoc(data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleSubmit = async (payload) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let apiPayload = {
        id: doc?.id,
        payload,
      };
      const data = await ApiService.post("update-tasks", apiPayload, headers);
      if (data.status === "Success") {
        setDoc(null);
        swal("Submitted Successfully", "").then(() => {
          getTask();
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const [isNotInvoice, setIsNotInvoice] = useState(false); // New state for checkbox

  // ... [rest of the existing functions]

  const handleCheckboxChange = () => {
    setIsNotInvoice(!isNotInvoice);
  }

  const handleNotInvoiceSubmit = async () => {
    // Logic for handling the submit action when checkbox is checked
    console.log('Document marked as not an invoice');
    // Add your submit logic here
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let apiPayload = {
        id: doc?.id,
        "payload": {},
        "isValidDoc": (isNotInvoice ? 'N' : 'Y')

      };
      const data = await ApiService.post("update-tasks", apiPayload, headers);
      if (data.status === "Success") {
        setDoc(null);
        swal("Submitted Successfully", "").then(() => {
          getTask();
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }

  }

  const handlePageChange = (newPageNumber) => {
    setPageNumber(newPageNumber);
  };

  const zoomIn = () => {
    setZoomLevel(zoomLevel + 0.1);
  };

  const zoomOut = () => {
    setZoomLevel(Math.max(zoomLevel - 0.1, 1.0));
  };
  return (
    <div className="layout-container">
      <div className="top-navbar">
        <div className="center-container">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Optional Invoice File Name"
              value={textBoxValue}
              onChange={(e) => setTextBoxValue(e.target.value)}
            />
            <button className="btn btn-primary" onClick={() => getTask(textBoxValue)}>
              Review Invoice
            </button>
          </div>
        </div>
        <div className="sign-out-group">
        <button className="btn btn-danger sign-out-button" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </div>

      <div className="content">
               
        {doc && isPdf(doc.signedURL) ? (
          <>         
            <div className="pdf-thumbnails">
            <div className="doc-metadata">
                  <div className="doc-metadata-content">
                    Batch<h4>{doc.payload.clientBatchId}</h4>
                    Folder: <h4>{doc.payload.folder}</h4>
                    File: <h4>{doc.clientItemId}</h4>

                  </div>
                  </div> 

              {doc?.signedURL ? (
                <div className="download-container">
                  <a href={doc?.signedURL} target="_blank" rel="noopener noreferrer">Download File</a>
                </div>
              ) : (
                <>
                </>
              )}
              <Document
                file={doc?.signedURL}
                onLoadSuccess={onDocumentLoadSuccess}
                className="document-thumbnails"
              >
                {Array.from({ length: numPages }, (_, index) => (
                  <div key={index} onClick={() => handlePageChange(index + 1)} className="thumbnail">
                    <Page
                      pageNumber={index + 1}
                      width={100}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                    />
                    <p>Page {index + 1}</p>
                  </div>
                ))}
              </Document>
            </div>
          </>
        ) : (
          <>

            {doc?.signedURL ? (
              
              <div className="pdf-thumbnails">
                      <div className="doc-metadata">
                  <div className="doc-metadata-content">
                    Batch<h4>{doc.payload.clientBatchId}</h4>
                    Folder: <h4>{doc.payload.folder}</h4>
                    File: <h4>{doc.clientItemId}</h4>

                  </div>

                  </div> 

                <div className="download-container">
                  <a href={doc?.signedURL} target="_blank" rel="noopener noreferrer">Download Document</a>
                </div>
              </div>

            ) : (
              <>
              </>
            )}
          </>
        )}


        {doc ? (
          <div className="form-block">

            <div className="row">
              {doc.prevPayload && doc.prevPayload.data && (
                <div className="col-6">
                  <div className="previous-review-data">
                    <div className="previous-review-content">
                      <p>{doc.prevPayloadDesc}</p>
                      <div className="not-invoice-panel">
                        <input
                          type="checkbox"
                          checked={doc.prevPayload.isValidDoc == 'N' ? true : false}
                          disabled={true}
                          readOnly
                        />
                        <label>Document is not an invoice</label>
                      </div>
                    </div>
                  </div>

                  <DynamicForm
                    schema={doc.schema}
                    payload={doc.prevPayload.data}
                    nonEditable={true}
                  />
                </div>
              )}
              <div className={doc.prevPayload && doc.prevPayload.data ? "col-6" : "col-12"}>
                <div className="previous-review-data">
                <p>Automated Review</p>
                  <div className="not-invoice-panel">
                    <input
                      type="checkbox"
                      checked={isNotInvoice}
                      onChange={handleCheckboxChange}
                    />
                    <label>Document is not an invoice</label>
                    <button onClick={handleNotInvoiceSubmit}>Submit</button>
                  </div>
                </div>
                <DynamicForm
                  schema={doc.schema}
                  payload={doc.payload.data}
                  postData={(e) => handleSubmit(e)}
                />
              </div>
            </div>
          </div>

        ) : (
          <></>
        )}
        {doc && isPdf(doc.signedURL) ? (
          <>
            <div className="pdf-viewer">
              <h4>Page View</h4>
              <div className="zoom-buttons">
                <button onClick={zoomIn}>Zoom In</button>
                <button onClick={zoomOut}>Zoom Out</button>
              </div>
              <Document
                file={doc?.signedURL}
                onLoadSuccess={onDocumentLoadSuccess}
                className="document-viewer"
              >
                <Page
                  pageNumber={pageNumber}
                  scale={zoomLevel}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>
            </div>
          </>

        ) : (
          <>
          </>
        )}

      </div>
    </div>
  );
};
export default Layout;
